/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';

// Checkout UI
import Calendar from './Calendar';

class CalendarView extends React.Component {
    showCalendar = (calendarDates) => {
        const showNavBtnFrYear = Object.keys(calendarDates).sort()[0];
        const showNavBtnFrMonth = Object.keys(calendarDates[showNavBtnFrYear]).sort()[0];
        return Object.keys(calendarDates).sort().map((Year, index) => (
            <Calendar
                /* eslint-disable react/no-array-index-key */
                key={index}
                year={Year}
                calendarData={calendarDates}
                showNavBtnFrYear={showNavBtnFrYear}
                showNavBtnFrMonth={showNavBtnFrMonth}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.props}
            />
        ));
    }

    render() {
        const { calendarDisplayData } = this.props;
        return (
            <Grid>
                { this.showCalendar(calendarDisplayData) }
            </Grid>
        );
    }
}

CalendarView.propTypes = {
    calendarDates: PropTypes.object,
    calendarDisplayData: PropTypes.object.isRequired,
    getMediumDayFormat: PropTypes.bool,
    getIconPlaceholder: PropTypes.bool,

};

CalendarView.defaultProps = {
    calendarDates: null,
    getMediumDayFormat: false,
    getIconPlaceholder: false,
};

export default CalendarView;
